import { Record, Union } from "../fable_modules/fable-library-js.4.25.0/Types.js";
import { CrudStateMachine_forceCreate, CrudStateMachine_states, CrudStateMachine_CrudTaggedStateMessages$4_$reflection, Crud_CrudTagModel$4_$reflection } from "./CrudMachine.js";
import { Shared_CrudInbound$2_$reflection, Shared_SharedCrudModel$4_$reflection } from "./SharedCrud.js";
import { view, update, StateMachineMsg$5, StateMachineModel$6_$reflection, StateMachineMsg$5_$reflection } from "../fable_modules/Webbler.StateMachine.Core.1.3.1/StateMachine.fs.js";
import { record_type, union_type } from "../fable_modules/fable-library-js.4.25.0/Reflection.js";
import { Cmd_map, Cmd_none } from "../fable_modules/Fable.Elmish.4.4.0/cmd.fs.js";
import { singleton } from "../fable_modules/fable-library-js.4.25.0/List.js";
import { error } from "../ThreeDocs.SharedUI/Toast.js";
import * as react from "react";

export class Types_Msg$4 extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CrudMsg", "SafeOutbound", "SafeInbound"];
    }
}

export function Types_Msg$4_$reflection(gen0, gen1, gen2, gen3) {
    return union_type("ThreeDocs.Client.StateMachine.Crud.CrudComponent.Types.Msg`4", [gen0, gen1, gen2, gen3], Types_Msg$4, () => [[["Item", StateMachineMsg$5_$reflection(Crud_CrudTagModel$4_$reflection(gen0, gen1, gen2, gen3), Shared_SharedCrudModel$4_$reflection(gen0, gen1, gen2, gen3), CrudStateMachine_CrudTaggedStateMessages$4_$reflection(gen0, gen1, gen2, gen3), Shared_CrudInbound$2_$reflection(gen0, gen3), gen1)]], [["Item", gen1]], [["Item", Shared_CrudInbound$2_$reflection(gen0, gen3)]]]);
}

export class Types_Model$4 extends Record {
    constructor(CrudMachineModel) {
        super();
        this.CrudMachineModel = CrudMachineModel;
    }
}

export function Types_Model$4_$reflection(gen0, gen1, gen2, gen3) {
    return record_type("ThreeDocs.Client.StateMachine.Crud.CrudComponent.Types.Model`4", [gen0, gen1, gen2, gen3], Types_Model$4, () => [["CrudMachineModel", StateMachineModel$6_$reflection(Crud_CrudTagModel$4_$reflection(gen0, gen1, gen2, gen3), Shared_SharedCrudModel$4_$reflection(gen0, gen1, gen2, gen3), CrudStateMachine_CrudTaggedStateMessages$4_$reflection(gen0, gen1, gen2, gen3), Shared_CrudInbound$2_$reflection(gen0, gen3), gen1, gen2)]]);
}

export function State_init(crudMachineLayoutConfig, crudMachineViewItemConfig, crudMachineItemConfig, initialCustomStorage) {
    return [new Types_Model$4(CrudStateMachine_states(crudMachineLayoutConfig, crudMachineViewItemConfig, crudMachineItemConfig, initialCustomStorage)), Cmd_none()];
}

export function State_update(token, msg, model) {
    switch (msg.tag) {
        case 2:
            return [model, singleton((dispatch) => {
                dispatch(new Types_Msg$4(0, [new StateMachineMsg$5(2, [msg.fields[0]])]));
            })];
        case 0:
            if (msg.fields[0].tag === 3) {
                return [model, singleton((dispatch_1) => {
                    dispatch_1(new Types_Msg$4(1, [msg.fields[0].fields[0]]));
                })];
            }
            else {
                const patternInput = update(token, msg.fields[0], model.CrudMachineModel);
                return [new Types_Model$4(patternInput[0]), Cmd_map((Item_2) => (new Types_Msg$4(0, [Item_2])), patternInput[1])];
            }
        default:
            return [model, error("Outbound command not handled.")];
    }
}

export function State_forceCreate(model) {
    return new Types_Model$4(CrudStateMachine_forceCreate(model.CrudMachineModel));
}

export function View_view(model, dispatch) {
    const children = [view(model.CrudMachineModel, (arg) => {
        dispatch(new Types_Msg$4(0, [arg]));
    })];
    return react.createElement("div", {}, ...children);
}

